export default {"src":"/_next/static/media/External_Data_Solutions.4d134abd.svg","height":506,"width":588};